import {
    MonitorWorkingProgressResponseInterface,
    TrackingTimePayloadInterface,
    TrackingTimeResponseInterface,
} from '@/models/trackingTime.model';
import axiosService from '@/services/axios/axios.service';

interface ScreenshotInfo {
    url: string;
    key: string;
    timestamp: string;
    time: string;
}

interface ScreenshotResponse {
    date: string;
    screenshots: ScreenshotInfo[];
    total: number;
}

const getTrackingTime = async (
    payload: TrackingTimePayloadInterface
): Promise<NonNullable<TrackingTimeResponseInterface>> => {
    const response = await axiosService.get(
        `/tracking-time/monitoring?page=${payload.page || 1}&limit=${payload?.limit || -1}&uid=${payload.uid || ''}`
    );
    return response.data;
};

const getMonitoringProgressTrackingTimeByAdmin = async (payload: {
    uid: string;
    date: Date | string;
    queryByMonth?: string | undefined;
}): Promise<NonNullable<MonitorWorkingProgressResponseInterface>> => {
    const res = await axiosService.get(
        `tracking-time/monitor-working-progress-by-admin?uid=${payload.uid}&date=${payload.date}&queryByMonth=${payload.queryByMonth || ''}`
    );
    return res.data;
};

const getScreenshotsByAdmin = async (payload: {
    uid: string;
    date: string;
}): Promise<ScreenshotResponse> => {
    const res = await axiosService.get(
        `tracking-time/admin/screenshots`,
        { params: { uid: payload.uid, date: payload.date } }
    );
    return res.data;
};

export { getTrackingTime, getMonitoringProgressTrackingTimeByAdmin, getScreenshotsByAdmin };
